import { EbTracing } from "./tracing";
import { EbUser } from "./user";
import { city } from "./city";
import { EcCountry } from "./country";
import { TTEvent } from "./tTEvent";
import { Statique } from "../utils/statique";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct";
import { MTEnum } from "./mtEnum";

export class EbPslApp{
	ebTtPslAppNum: number;
	dateCreation: Date;
	dateActuelle: Date;
	dateNegotiation: Date;
	dateEstimee: Date;
	xEcCountry: EcCountry;
	city: string;
	xEbUser: EbUser;
	xEbTrackTrace: EbTracing;
    codePsl: MTEnum;
    codePslCode: number;
    codePslLibelle?: String;
	validated: Boolean;
	commentaire: string;
    listEvent: Array<TTEvent>;
	exists: Boolean;
	active: Boolean;

    dateActuelleSTR:string;
    dateEstimeeSTR:string;
    constructor(){
        this.codePslLibelle = null;
        this.ebTtPslAppNum = null;
        this.dateCreation = null;
        this.dateActuelle = null;
        this.dateNegotiation = null;
        this.dateEstimee = null;
        this.xEcCountry = new EcCountry();
        this.city = null;
        this.xEbUser = new EbUser();
        this.xEbTrackTrace = null;
        this.codePsl = null;
        this.codePslCode = null;
        this.codePslLibelle = null;
        this.validated = null;
        this.commentaire = null;
        this.listEvent = new Array();
        this.exists = false;
        this.active = false;
        this.dateActuelleSTR=null;
        this.dateEstimeeSTR=null;
    }

    clone(data: EbPslApp){
        this.codePslLibelle = data.codePslLibelle;
        this.codePslCode = data.codePslCode;
        this.ebTtPslAppNum = data.ebTtPslAppNum;
        if(data.xEcCountry)
            this.xEcCountry = data.xEcCountry;
        this.city = data.city;
        if(data.xEbUser)
            this.xEbUser = data.xEbUser;
        this.xEbTrackTrace = data.xEbTrackTrace;
        this.codePsl = data.codePsl;
        this.validated = data.validated;
        this.commentaire = data.commentaire;
        this.exists = data.exists;
        if(data.listEvent)
            this.listEvent = Statique.cloneObject(data.listEvent);
        this.active = data.active;
        
        this.dateEstimee = data.dateEstimee ? new Date(data.dateEstimee) : null;
        this.dateCreation = data.dateCreation? new Date(data.dateCreation) : null;
        this.dateActuelle = data.dateActuelle? new Date(data.dateActuelle) : null;
        this.dateNegotiation = data.dateNegotiation? new Date(data.dateNegotiation) : null;

        this.dateActuelleSTR=data.dateActuelleSTR;
        this.dateEstimeeSTR=data.dateEstimeeSTR;
    }
}


// WEBPACK FOOTER //
// ./src/app/classes/pslApp.ts